<template>
  <div>
    <template v-if="$membershipHasPermissionTo('create pages')">
      <div class="bg-white p-4 rounded border border-gray-400">
        <BaseButton primary @click="initializeCreateForm"> Create new </BaseButton>

        <BaseButton primary class="ml-2" @click="setModalLinkExistingVisible(true)">
          Add Existing
        </BaseButton>
      </div>
    </template>

    <Pages :loading="pending" :pages="pages" class="mt-4" @page-deleted="removePageId" />

    <template v-if="$membershipHasPermissionTo('create pages')">
      <portal v-if="modalCreateOrEditVisible" to="app-dialog">
        <ModalCreateOrEdit
          :account-id="$route.params.accountId"
          :project-uuid="projectId"
          :action="doStore"
          close-on-success
          @closed="modalCreateOrEditVisible = false"
        />
      </portal>
    </template>

    <template v-if="$membershipHasPermissionTo('create pipelines')">
      <portal v-if="modalLinkExistingVisible" to="app-dialog">
        <ModalLinkExisting
          :account-uuid="$route.params.accountId"
          :project-uuid="projectId"
          @closed="modalLinkExistingVisible = false"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Pages from '@/components/Pages/Index.vue';
import ModalCreateOrEdit from '@/components/ProjectPage/ModalCreateOrEdit.vue';
import ModalLinkExisting from '@/components/ProjectPage/ModalLinkExisting.vue';

export default {
  components: {
    Pages,
    ModalCreateOrEdit,
    ModalLinkExisting,
  },

  props: {
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
    modalCreateOrEditVisible: false,
    modalLinkExistingVisible: false,
  }),

  computed: {
    ...mapState('ui/projectPages', ['ids']),
    ...mapGetters('ui/projectPages', ['pages']),
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/projectPages', {
      loadPages: 'load',
      storePage: 'store',
    }),

    ...mapMutations('ui/projectPages', ['setIds', 'setMeta', 'setLinks']),

    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        await this.loadPages({
          projectUuid: projectId,
          params: {
            include: 'tags',
          },
        });
      } catch (error) {
        //
      }

      this.pending = false;
    },

    initializeCreateForm() {
      this.modalCreateOrEditVisible = true;
    },

    setModalLinkExistingVisible(bool) {
      this.modalLinkExistingVisible = bool;
    },

    doStore(params) {
      return this.storePage({ projectUuid: this.projectId, params });
    },

    removePageId(pageId) {
      this.setIds(this.ids.filter((id) => id !== pageId));
    },
  },
};
</script>
